import { Database, History, type LucideIcon, Search, Sparkles, Star } from 'lucide-react'

import type { FoodListKind, SheetTab } from './palette-utils'

type TabDef<K extends SheetTab> = { kind: K; label: string; shortLabel: string; Icon: LucideIcon; color: string }

const SEARCH_TAB: TabDef<'search'> = {
  kind: 'search',
  label: '食べたものを検索',
  shortLabel: '検索',
  Icon: Search,
  color: 'text-foreground',
}

/** 検索以外のタブ（パレットのボタンと、シートのタブで共通） */
export const FOOD_LISTS: TabDef<FoodListKind>[] = [
  { kind: 'ai', label: 'AI で解析', shortLabel: 'AI', Icon: Sparkles, color: 'text-violet-400' },
  { kind: 'favorites', label: 'お気に入りの一覧', shortLabel: 'お気に入り', Icon: Star, color: 'text-amber-400' },
  { kind: 'history', label: '履歴の一覧', shortLabel: '履歴', Icon: History, color: 'text-sky-400' },
  { kind: 'db', label: 'DB で検索', shortLabel: 'DB', Icon: Database, color: 'text-emerald-400' },
]

/** 食事シートのタブ（検索 → AI → お気に入り → 履歴 → DB） */
export const SHEET_TABS: TabDef<SheetTab>[] = [SEARCH_TAB, ...FOOD_LISTS]
